import React, { FC, useEffect, useMemo, useState } from "react";
import { KeyboardAvoidingView, View, VirtualizedList, useWindowDimensions } from "react-native";
import CommonHeader from "../../../../shared/commonComponents/commonHeader";
import { appColors } from "../../../../themes/appTheme";
import { ThemeConsumer } from "@rneui/themed";
import { useIsFocused, useNavigation } from '@react-navigation/native';
import { config } from "../../../../shared/environment";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { getStoreLocation } from "../../../../redux/slices/commonSlice";
import { DropdownProps } from "../productModule";
import { ZenDivider, ZenDropdown, ZenText } from "zen-core-elements";
import { fontSize } from "zen-core-elements/src/shared/constants";

const InventoryAdjustmentHistory: FC = () => {

    const history = [{
        'staff': 'Smit', 'stockOnHand': 4, 'commitedStock': 0, 'unavailable': 3, 'availableForSale': 0, 'incoming': 0, 'lowstock': 0, 'reason': 'moved from safety stock', 'Activity': 'Move to available', 'date&time': '01-11-2023'
    }]
    //State variable to use useAppDispatch hook
    const dispatch = useAppDispatch()
    const { width } = useWindowDimensions();

    const [isLocationOpen, setIsLocationOpen] = useState<boolean>(false)
    const [location, setLocation] = useState<any>()

    const navigation: any = useNavigation();

    //State variable to use useIsFocused hook to notify the page is focused or not
    const isFocused = useIsFocused();

    const { value } = useAppSelector((state) => state.common.getStoreLocations)

    //useEffect to render the when the focused value changes
    useEffect(() => {
        if (isFocused) {
            // setIsLoading(true)
            dispatch(getStoreLocation()).then((res) => {
            })
        }
    }, [isFocused])

    //useMemo function to render the when the location value from redux store changes
    const locationData: DropdownProps[] | any = useMemo(() => {
        if (value) {
            let locationData: DropdownProps[] = []
            value?.location?.map((val) => {
                locationData.push({ value: val.id, label: val.locationName })
            })
            return locationData
        }
    }, [value])

    const renderItem = ({ item, index }: any) => {
        return (
            <ThemeConsumer>
                {({ theme }: any) => (
                    item?.map((content: any, i: number) => (
                        <View key={i} style={theme.inventoryAdjustmentHistoryStyle.cardContainerView} >
                            <View style={theme.inventoryAdjustmentHistoryStyle.headerSection}>
                                <ZenText content="Smith" style={{ fontSize: fontSize?.mediumFontSize }} bold={true} color={appColors.primary} />
                                <View style={{ flexDirection: 'row' }}>
                                    <ZenText content="Created at " style={{ fontSize: fontSize?.smallHeaderFontSize }} color={appColors.labelColor} />
                                    <ZenText content="01/11/23" style={{ fontSize: fontSize?.smallHeaderFontSize }} bold={true} color={appColors.lightDark} />
                                </View>
                            </View>
                            <ZenDivider style={{ paddingVertical: 5 }} />
                            {
                                width > 600 ?
                                    <View style={theme.inventoryAdjustmentHistoryStyle.contentSection}>
                                        <View style={{ flex: width > 900 ? 0.2 : 0.23 }}>
                                            <View style={theme.inventoryAdjustmentHistoryStyle.viewStyle}>
                                                <ZenText content="Stock on hand: " style={{ paddingTop: 10, fontSize: fontSize?.smallHeaderFontSize }} color={appColors.labelColor} />
                                                <ZenText content="4" style={{ paddingTop: 10, fontSize: fontSize?.smallHeaderFontSize }} bold={true} color={appColors.lightDark} />
                                            </View>
                                            <View style={theme.inventoryAdjustmentHistoryStyle.viewStyle}>
                                                <ZenText content="Commited stock: " style={{ paddingTop: 10, fontSize: fontSize?.smallHeaderFontSize }} color={appColors.labelColor} />
                                                <ZenText content="0" style={{ paddingTop: 10, fontSize: fontSize?.smallHeaderFontSize }} bold={true} color={appColors.lightDark} />
                                            </View>
                                        </View>
                                        <View style={{ flex: width > 900 ? 0.2 : 0.23 }}>
                                            <View style={theme.inventoryAdjustmentHistoryStyle.viewStyle}>
                                                <ZenText content="Unavailable: " style={{ paddingTop: 10, fontSize: fontSize?.smallHeaderFontSize }} color={appColors.labelColor} />
                                                <ZenText content="3" style={{ paddingTop: 10, fontSize: fontSize?.smallHeaderFontSize }} bold={true} color={appColors.lightDark} />
                                            </View>
                                            <View style={theme.inventoryAdjustmentHistoryStyle.viewStyle}>
                                                <ZenText content="Available for sale: " style={{ paddingTop: 10, fontSize: fontSize?.smallHeaderFontSize }} color={appColors.labelColor} />
                                                <ZenText content="0" style={{ paddingTop: 10, fontSize: fontSize?.smallHeaderFontSize }} bold={true} color={appColors.lightDark} />
                                            </View>
                                        </View>
                                        <View style={{ flex: width > 900 ? 0.2 : 0.18 }}>
                                            <View style={theme.inventoryAdjustmentHistoryStyle.viewStyle}>
                                                <ZenText content="Incoming: " style={{ paddingTop: 10, fontSize: fontSize?.smallHeaderFontSize }} color={appColors.labelColor} />
                                                <ZenText content="0" style={{ paddingTop: 10, fontSize: fontSize?.smallHeaderFontSize }} bold={true} color={appColors.lightDark} />
                                            </View>
                                            <View style={theme.inventoryAdjustmentHistoryStyle.viewStyle}>
                                                <ZenText content="Low stock: " style={{ paddingTop: 10, fontSize: fontSize?.smallHeaderFontSize }} color={appColors.labelColor} />
                                                <ZenText content="0" style={{ paddingTop: 10, fontSize: fontSize?.smallHeaderFontSize }} bold={true} color={appColors.lightDark} />
                                            </View>
                                        </View>
                                        <View style={{ flex: width > 900 ? 0.4 : 0.3 }}>
                                            <View style={theme.inventoryAdjustmentHistoryStyle.viewStyle}>
                                                <ZenText content="Reason: " style={{ paddingTop: 10, fontSize: fontSize?.smallHeaderFontSize }} color={appColors.labelColor} />
                                                <ZenText content="Moved from safety stock" style={{ paddingTop: 10, fontSize: fontSize?.smallHeaderFontSize }} bold={true} color={appColors.lightDark} />
                                            </View>
                                            <View style={theme.inventoryAdjustmentHistoryStyle.viewStyle}>
                                                <ZenText content="Activity: " style={{ paddingTop: 10, fontSize: fontSize?.smallHeaderFontSize }} color={appColors.labelColor} />
                                                <ZenText content="Move to available" style={{ paddingTop: 10, fontSize: fontSize?.smallHeaderFontSize }} bold={true} color={appColors.lightDark} />
                                            </View>
                                        </View>
                                    </View>
                                    :
                                    <View style={theme.inventoryAdjustmentHistoryStyle.contentSection}>
                                        <View style={{ flex: 0.5 }}>
                                            <View style={theme.inventoryAdjustmentHistoryStyle.viewStyle}>
                                                <ZenText content="Stock on hand: " style={{ paddingTop: 10, fontSize: fontSize?.smallHeaderFontSize }} color={appColors.labelColor} />
                                                <ZenText content="4" style={{ paddingTop: 10, fontSize: fontSize?.smallHeaderFontSize }} bold={true} color={appColors.lightDark} />
                                            </View>
                                            <View style={theme.inventoryAdjustmentHistoryStyle.viewStyle}>
                                                <ZenText content="Unavailable: " style={{ paddingTop: 10, fontSize: fontSize?.smallHeaderFontSize }} color={appColors.labelColor} />
                                                <ZenText content="3" style={{ paddingTop: 10, fontSize: fontSize?.smallHeaderFontSize }} bold={true} color={appColors.lightDark} />
                                            </View>
                                            <View style={theme.inventoryAdjustmentHistoryStyle.viewStyle}>
                                                <ZenText content="Incoming: " style={{ paddingTop: 10, fontSize: fontSize?.smallHeaderFontSize }} color={appColors.labelColor} />
                                                <ZenText content="0" style={{ paddingTop: 10, fontSize: fontSize?.smallHeaderFontSize }} bold={true} color={appColors.lightDark} />
                                            </View>
                                            <View style={theme.inventoryAdjustmentHistoryStyle.viewStyle}>
                                                <ZenText content="Reason: " style={{ paddingTop: 10, fontSize: fontSize?.smallHeaderFontSize }} color={appColors.labelColor} />
                                                <ZenText content="Moved from safety stock" style={{ paddingTop: 10, width: 100, fontSize: fontSize?.smallHeaderFontSize }} bold={true} color={appColors.lightDark} />
                                            </View>
                                        </View>
                                        <View style={{ flex: 0.5 }}>
                                            <View style={theme.inventoryAdjustmentHistoryStyle.viewStyle}>
                                                <ZenText content="Commited stock: " style={{ paddingTop: 10, fontSize: fontSize?.smallHeaderFontSize }} color={appColors.labelColor} />
                                                <ZenText content="0" style={{ paddingTop: 10, fontSize: fontSize?.smallHeaderFontSize }} bold={true} color={appColors.lightDark} />
                                            </View>
                                            <View style={theme.inventoryAdjustmentHistoryStyle.viewStyle}>
                                                <ZenText content="Available for sale: " style={{ paddingTop: 10, fontSize: fontSize?.smallHeaderFontSize }} color={appColors.labelColor} />
                                                <ZenText content="0" style={{ paddingTop: 10, fontSize: fontSize?.smallHeaderFontSize }} bold={true} color={appColors.lightDark} />
                                            </View>
                                            <View style={theme.inventoryAdjustmentHistoryStyle.viewStyle}>
                                                <ZenText content="Low stock: " style={{ paddingTop: 10, fontSize: fontSize?.smallHeaderFontSize }} color={appColors.labelColor} />
                                                <ZenText content="0" style={{ paddingTop: 10, fontSize: fontSize?.smallHeaderFontSize }} bold={true} color={appColors.lightDark} />
                                            </View>
                                            <View style={theme.inventoryAdjustmentHistoryStyle.viewStyle}>
                                                <ZenText content="Activity: " style={{ paddingTop: 10, fontSize: fontSize?.smallHeaderFontSize }} color={appColors.labelColor} />
                                                <ZenText content="Move to available" style={{ paddingTop: 10, fontSize: fontSize?.smallHeaderFontSize }} bold={true} color={appColors.lightDark} />
                                            </View>
                                        </View>
                                    </View>
                            }
                        </View>
                    ))
                )}
            </ThemeConsumer>
        )
    }

    return (
        <ThemeConsumer>
            {({ theme }: any) => (
                <KeyboardAvoidingView style={theme.inventoryAdjustmentHistoryStyle.containerView}>
                    <CommonHeader backIcon backIconOnpress={() => { navigation.goBack() }} headerName="Inventory Adjustment History" />
                    <View style={{ margin: 10, alignItems: 'flex-end', right: 10, }}>
                        <ZenDropdown
                            placeholder="Choose location"
                            items={locationData ? locationData : []}
                            open={isLocationOpen}
                            setOpen={() => { setIsLocationOpen(!isLocationOpen) }}
                            value={location}
                            setValue={() => { location }}
                            multiple={false}
                            onSelectItem={(data) => { setLocation(data?.value) }}
                            containerStyle={{ width: width > 900 ? 300 : 200, marginVertical: 10, }}
                            style={{ minHeight: 45 }} />
                    </View>
                    <View style={{ flex: 1 }}>
                        <VirtualizedList
                            data={history}
                            renderItem={renderItem}
                            getItemCount={() => (1)}
                            getItem={(data, index) => {
                                let items = [];
                                let numColumns = 1;
                                for (let i = 0; i < numColumns; i++) {
                                    const item = data[index * numColumns + i];
                                    item && items.push(item)
                                }
                                return items
                            }}
                            keyExtractor={(item, index) => index.toString()}
                        />
                    </View>
                </KeyboardAvoidingView>
            )}
        </ThemeConsumer>

    )
}

export default InventoryAdjustmentHistory